import { lazy } from "react";

const Login = lazy(() => import("@Pages/Login"));
// const Signup = lazy(() => import("@Pages/Signup"));
const ForgotPassword = lazy(() => import("@Pages/ForgotPassword"));
const ResetPassword = lazy(() => import("@Pages/ResetPassword"));
const SetNewPassword = lazy(() => import("@Pages/SetNewPassword"));

const Zones = lazy(() => import("../Pages/Zones/zones"));
const Wards = lazy(() => import("../Pages/Wards/wards"));
const AdminUsers = lazy(() => import("../Pages/AdminUsers/adminusers"));
const AdminUsersList = lazy(() => import("../Pages/AdminUsers/adminUsersList"));

const RolesList = lazy(() => import("../Pages/Roles/rolesList"));
const AddNewRole = lazy(() => import("../Pages/Roles/addNewRole"));

const PermissionList = lazy(() => import("../Pages/Roles/PermissionList"));

const Profile = lazy(() => import("../Pages/Profile/Profile"));

// const MunicipalAdminDashboard = lazy(() =>
//   import("../Pages/Dashboard/MunicipalAdminDashboard")
// );

const NotFound = lazy(() => import("../Pages/NotFound"));
// const DefaultDashboard = lazy(() =>
//   import("../Pages/Dashboard/DefaultDashboard")
// );
const Dashboard = lazy(() => import("../Pages/Dashboard/Dashboard"));
const Locations = lazy(() => import("../Pages/Locations/Locations"));
const LocationDetail = lazy(() => import("../Pages/Locations/LocationDetails"));
const Devices = lazy(() => import("../Pages/Devices/Devices"));
const DeviceDetail = lazy(() => import("../Pages/Devices/DeviceDetail"));
const DeviceOta = lazy(() => import("../Pages/DeviceOta/DeviceOtaUpload"));
const DeviceOtaMonitor = lazy(
  () => import("../Pages/DeviceOta/DeviceOtaMonitor"),
);
const States = lazy(() => import("../Pages/State/States"));
const Cities = lazy(() => import("../Pages/City/Cities"));
const Config = lazy(() => import("../Pages/Config/Config"));
const all = "all";

export const publicRoutes = [
  {
    path: "/login",
    element: Login,
  },
  // {
  //   path: "/signup",
  //   element: Signup,
  // },
  {
    path: "/forgot-password",
    element: ForgotPassword,
  },
  {
    path: "/reset-password",
    element: ResetPassword,
  },
  {
    path: "/set-new-password",
    element: SetNewPassword,
  },
];

export const privateRoutes = [
  {
    path: "/zones",
    element: Zones,
    roles: "zones-list",
  },
  {
    path: "/wards",
    element: Wards,
    roles: "wards-list",
  },

  {
    path: "/admin-users",
    element: AdminUsersList,
    roles: "admin-user-list",
  },
  {
    path: "/admin-users/add",
    element: AdminUsers,
    roles: "admin-user-create",
  },
  {
    path: "/admin-users/edit/:id",
    element: AdminUsers,
    roles: "admin-user-edit",
  },
  {
    path: "/roles",
    element: RolesList,
    roles: "role-list",
  },
  {
    path: "/roles/add",
    element: AddNewRole,
    roles: "role-create",
  },
  {
    path: "/roles/edit/:id",
    element: AddNewRole,
    roles: "role-edit",
  },
  {
    path: "/permissions",
    element: PermissionList,
    roles: "permission-list",
  },
  {
    path: "/profile",
    element: Profile,
    roles: all,
  },
  {
    path: "/user-not-found",
    element: NotFound,
    roles: all,
  },
  {
    path: "/dashboard",
    element: Dashboard,
    roles: "dashboard",
  },

  {
    path: "/locations",
    element: Locations,
    roles: "locations-list",
  },
  {
    path: "/locations/:id",
    element: LocationDetail,
    roles: "locations-view",
  },
  {
    path: "/devices",
    element: Devices,
    roles: "device-list",
  },
  {
    path: "/devices/:id",
    element: DeviceDetail,
    roles: "device-view",
  },
  {
    path: "/device-ota",
    element: DeviceOta,
    roles: "device-ota-list",
  },
  {
    path: "/device-ota/monitor",
    element: DeviceOtaMonitor,
    roles: "device-ota-list",
  },

  {
    path: "/states",
    element: States,
    roles: "state-list",
  },
  {
    path: "/cities",
    element: Cities,
    roles: "city-list",
  },
  {
    path: "/config",
    element: Config,
    roles: "config-list",
  },
];
